export function getMenu() {

  const LOGO = '/images/Logo.webp'

  return [
  {
    id: 5,
    nombre: "CAPIBERRY",
    descripcion: "Crujiente crepa rellena de una dupla de frutas frescas, bañada en jarabe dulce y coronada con tu topping favorito, para un estallido frutal en cada bocado.",
    precio: 4600,
    imagenes: [LOGO],
    ingredientes: ["2 frutas", "Jarabe", "Topping"],
    disponible: true,
    categoria: "Crepas",
  },
  {
    id: 6,
    nombre: "CREPA SIN FRUTA",
    descripcion: "Suave crepa ligera, abrazando una generosa porción de helado cremoso, rematada con un toque extra de topping y jarabe al gusto.",
    precio: 4000,
    imagenes: ["/images/menuImages/crepas/CrepaSinFruta1.webp"],
    ingredientes: ["Helado", "Topping", "Jarabe"],
    disponible: true,
    categoria: "Crepas",
  },
  {
    id: 7,
    nombre: "TROPICALVARA",
    descripcion: "Refrescante crepa de inspiración caribeña, rellena de banano y fresas, acompañada de una bola de helado y un hilo de jarabe exótico.",
    precio: 4900,
    imagenes: ["/images/menuImages/crepas/TropicalVara1.webp"],
    ingredientes: ["Banano", "Fresas", "Helado", "Jarabe"],
    disponible: true,
    categoria: "Crepas",
  },
  {
    id: 8,
    nombre: "CAPIDULZURA",
    descripcion: "Delicada crepa que combina melocotón jugoso, fresas frescas y Nutella, con un suave helado que intensifica su dulce ternura.",
    precio: 5900,
    imagenes: ["/images/menuImages/crepas/CrepiDulzura1.webp"],
    ingredientes: ["Melocotón", "Fresa", "Helado", "Nutella"],
    disponible: true,
    categoria: "Crepas",
  },
  {
    id: 9,
    nombre: "CAPIOREO",
    descripcion: "Irresistible crepa con una fusión de frutas, crujientes trozos de Oreo, cremoso helado y un generoso chorrito de jarabe y topping.",
    precio: 6500,
    imagenes: ["/images/menuImages/crepas/CapiOreo.webp"],
    ingredientes: ["2 frutas", "Helado", "Oreo", "Jarabe", "Topping"],
    disponible: true,
    categoria: "Crepas",
  },
  {
    id: 10,
    nombre: "LA CREPIVARA",
    descripcion: "La reina de las crepas: tres frutas frescas, dos bolas de helado, un hilo de Nutella, crema chantilly y topping, para los paladares más exigentes.",
    precio: 7500,
    imagenes: ["/images/menuImages/crepas/CrepiVara1.webp"],
    ingredientes: ["3 frutas", "2 Helados", "Topping", "Crema Chantilly", "Nutella"],
    disponible: true,
    categoria: "Crepas",
  },
  {
    id: 11,
    nombre: "BATIDO NATURAL (EN AGUA)",
    descripcion: "Batido natural en agua con tu elección de frutas frescas, lleno de vitaminas y sabor ligero para refrescar tu día.",
    precio: 2450,
    imagenes: [LOGO],
    ingredientes: ["Cas", "Mora", "Piña", "Sandía", "Guanabana", "Fresa", "Mora"],
    disponible: true,
    categoria: "Bebidas Frías",
  },
  {
    id: 12,
    nombre: "BATIDO EN LECHE",
    descripcion: "Creamy batido en leche con mezcla tropical de frutas, para un antojo suave y reconfortante.",
    precio: 2800,
    imagenes: [LOGO],
    ingredientes: ["Mora", "Piña", "Guanabana", "Banano", "Papaya", "Fresa", "Melón"],
    disponible: true,
    categoria: "Bebidas Frías",
  },
  {
    id: 13,
    nombre: "CHURCHILL",
    descripcion: "Bebida emblemática de la costa: mezcla de helado, granizado y toppings que explotan en frescura y dulzura.",
    precio: 3900,
    imagenes: [LOGO],
    ingredientes: [""],
    disponible: true,
    categoria: "Bebidas Frías",
  },
  {
    id: 14,
    nombre: "CAFÉ FRIO",
    descripcion: "Clásico café frío, fuerte y revitalizante, perfecto para mantenerte despierto bajo el sol.",
    precio: 2800,
    imagenes: [LOGO],
    ingredientes: [""],
    disponible: true,
    categoria: "Bebidas Frías",
  },
  {
    id: 15,
    nombre: "MANGONADAS",
    descripcion: "Deliciosa mezcla de mango fresco, chamoy, tajín y gomitas, creando la explosión de sabores más divertida.",
    precio: 2800,
    imagenes: [LOGO],
    ingredientes: ["Mango", "Tajín", "Chamoy", "Gomitas"],
    disponible: true,
    categoria: "Bebidas Frías",
  },
  {
    id: 16,
    nombre: "TÉ",
    descripcion: "Infusión caliente de té suave, perfecta para reconfortar el paladar.",
    precio: 1000,
    imagenes: ["/images/menuImages/bebidas/te.webp"],
    ingredientes: [""],
    disponible: true,
    categoria: "Bebidas Calientes",
  },
  {
    id: 17,
    nombre: "CAFÉ NEGRO",
    descripcion: "Café caliente y puro, con cuerpo intenso y aroma profundo para los amantes del espresso.",
    precio: 1000,
    imagenes: ["/images/menuImages/bebidas/CafeNegro.webp"],
    ingredientes: [""],
    disponible: true,
    categoria: "Bebidas Calientes",
  },
  {
    id: 18,
    nombre: "CAFÉ CON LECHE",
    descripcion: "Suave mezcla de café y leche caliente, cremosa y reconfortante en cada sorbo.",
    precio: 1300,
    imagenes: ["/images/menuImages/bebidas/CafeConLeche.webp"],
    ingredientes: [""],
    disponible: true,
    categoria: "Bebidas Calientes",
  },
  {
    id: 19,
    nombre: "CHOCOLATE",
    descripcion: "Chocolate caliente espeso y reconfortante, ideal para endulzar tu jornada.",
    precio: 1500,
    imagenes: ["/images/menuImages/bebidas/Chocolate.webp"],
    ingredientes: [""],
    disponible: true,
    categoria: "Bebidas Calientes",
  },
  {
    id: 20,
    nombre: "HELADO CON GELATINA Y FRUTAS",
    descripcion: "Divertida combinación de helado cremoso con trozos de gelatina fresca, textura y sabor en armonía.",
    precio: 3700,
    imagenes: [LOGO],
    ingredientes: ["1 helado", "Gelatina"],
    disponible: true,
    categoria: "Helados",
  },
  {
    id: 21,
    nombre: "ENSALADA DE FRUTAS",
    descripcion: "Ensalada vibrante con una bola de helado, tres frutas de temporada y un topping crocante.",
    precio: 3700,
    imagenes: [LOGO],
    ingredientes: ["3 frutas", "1 Helado", "1 Topping"],
    disponible: true,
    categoria: "Helados",
  },
  {
    id: 22,
    nombre: "CANASTA CON HELADO",
    descripcion: "Deliciosa canasta crujiente que abraza una porción de helado, perfecta para compartir o disfrutar solo.",
    precio: 4200,
    imagenes: [LOGO],
    ingredientes: [""],
    disponible: true,
    categoria: "Helados",
  },
  {
    id: 23,
    nombre: "CHOCO BANANO ESPECIAL",
    descripcion: "Batido cremoso de leche Pinito con jarabe, topping y plátano cubierto de chocolate fundido.",
    precio: 1600,
    imagenes: [LOGO],
    ingredientes: ["Leche Pinito", "1 Jarabe", "1 Topping"],
    disponible: true,
    categoria: "Helados",
  },
  {
    id: 24,
    nombre: "BANANA SPLIT",
    descripcion: "Clásico banana split con rodajas de banano, dos helados, chantilly, jarabe y tu topping favorito.",
    precio: 3900,
    imagenes: [LOGO],
    ingredientes: ["Banano", "Helado", "1 Topping", "1 Jarabe", "Chantilly"],
    disponible: true,
    categoria: "Helados",
  },
  {
    id: 25,
    nombre: "GRANIZADO SENCILLO",
    descripcion: "Refrescante granizado de leche con sirope, ideal para calmar el calor al instante.",
    precio: 1000,
    imagenes: [LOGO],
    ingredientes: ["1 Leche", "Sirope"],
    disponible: true,
    categoria: "Granizados",
  },
  {
    id: 26,
    nombre: "GRANIZADO ESPECIAL",
    descripcion: "Granizado doble con dos leches, sirope, topping y jarabe, para una experiencia más indulgente.",
    precio: 1500,
    imagenes: [LOGO],
    ingredientes: ["2 Leches", "Sirope", "1 Topping", "1 Jarabe"],
    disponible: true,
    categoria: "Granizados",
  },
  {
    id: 27,
    nombre: "FRESA PEQUEÑA",
    descripcion: "Fresa fresca bañada en sirope y coronada con un ligero topping, ideal para un dulce bocado rápido.",
    precio: 2300,
    imagenes: [LOGO],
    ingredientes: ["1 Topping", "1 Jarabe"],
    disponible: true,
    categoria: "Fresas",
  },
  {
    id: 28,
    nombre: "FRESA GRANDE",
    descripcion: "Generosa fresa cubierta de dos jarabes y doble topping, perfecta para compartir o disfrutar a solas.",
    precio: 3400,
    imagenes: [LOGO],
    ingredientes: ["2 Topping", "2 Jarabe"],
    disponible: true,
    categoria: "Fresas",
  },
  {
    id: 29,
    nombre: "WAFFLE Con Helado",
    descripcion: "Caliente waffle crujiente servido con dos porciones de helado, frutas frescas, jarabe y topping.",
    precio: 5900,
    imagenes: ["/images/menuImages/waffles/Waffles.webp"],
    ingredientes: ["2 Frutas", "1 Topping", "1 Jarabe", "2 Helados"],
    disponible: true,
    categoria: "Fresas",
  },
  {
    id: 30,
    nombre: "WAFFLE SENCILLO",
    descripcion: "Clásico waffle dorado con frutas frescas, jarabe y topping, sencillo pero lleno de sabor.",
    precio: 5300,
    imagenes: [LOGO],
    ingredientes: ["2 frutas", "1 Topping", "1 Jarabe"],
    disponible: true,
    categoria: "Fresas",
  },
  {
    id: 31,
    nombre: "TOPPING",
    descripcion: "Tu opción de topping favorito para realzar cualquier postre con un toque extra de sabor y textura.",
    precio: 350,
    imagenes: [LOGO],
    ingredientes: [""],
    disponible: true,
    categoria: "Extras",
  },
  {
    id: 32,
    nombre: "JARABE",
    descripcion: "Jarabe dulce listo para bañar tus crepas, waffles o helados y darles un acabado glaseado.",
    precio: 500,
    imagenes: [LOGO],
    ingredientes: [""],
    disponible: true,
    categoria: "Extras",
  },
  {
    id: 33,
    nombre: "Helado",
    descripcion: "Porción de helado cremoso, perfecto para acompañar crepas, waffles o solo como postre refrescante.",
    precio: 600,
    imagenes: [LOGO],
    ingredientes: [""],
    disponible: true,
    categoria: "Extras",
  },
  {
    id: 34,
    nombre: "NUTELLA",
    descripcion: "Porción extra de Nutella para los amantes del chocolate y avellanas, ideal para untar en crepas y postres.",
    precio: 700,
    imagenes: [LOGO],
    ingredientes: [""],
    disponible: true,
    categoria: "Extras",
  }
];
}


//Id de las recomendadas de 1000 para arriba
export function getRecommended(){

   return [
    getMenu().find(item => item.id === 10),
    getMenu().find(item => item.id === 8),
    getMenu().find(item => item.id === 29),
    getMenu().find(item => item.id === 12),
  ]
}
